import { render, staticRenderFns } from "./ResumeGameNotice.vue?vue&type=template&id=53086fc0&scoped=true&"
import script from "./ResumeGameNotice.vue?vue&type=script&lang=js&"
export * from "./ResumeGameNotice.vue?vue&type=script&lang=js&"
import style0 from "./ResumeGameNotice.vue?vue&type=style&index=0&id=53086fc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53086fc0",
  null
  
)

export default component.exports